import * as z from 'zod';
import '../../../../types/actor/actor.mjs';
import '../../../../types/address/address.mjs';
import '../../../../types/credit-report/company-credit-report.mjs';
import '../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../types/currency/currency.mjs';
import '../../../../types/entityRelation/entity-relation.mjs';
import '../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../types/financial-formula/adjustment.mjs';
import '../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../types/is-encrypted.mjs';
import '../../../../types/naics-codes/naics-codes.mjs';
import { sfaaCodeId } from '../../../../types/opaque.mjs';
import '../../../../types/surety/account/requested-limits.mjs';
import '../../../../types/surety/account/surety-account.types.mjs';
import '../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../types/surety/application-extraction/application-review.mjs';
import '../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../types/user/user.types.mjs';
import { currencySchema } from '../../../../types/utils.mjs';
import { Get as Get$1, Import as Import$1, Close as Close$1 } from './contract/admin-contract-surety-bond.dto.mjs';
import * as adminContractSuretyBond_dto from './contract/admin-contract-surety-bond.dto.mjs';
export { adminContractSuretyBond_dto as Contract };

var Trailing90DayGwp;
(function (Trailing90DayGwp) {
    (function (Get) {
        (function (Response) {
            Response.schema = z.object({
                gwp: currencySchema,
                bondCount: z.number(),
                priorGwp: currencySchema,
                series: z.array(currencySchema),
            });
        })(Get.Response || (Get.Response = {}));
    })(Trailing90DayGwp.Get || (Trailing90DayGwp.Get = {}));
})(Trailing90DayGwp || (Trailing90DayGwp = {}));
var Get;
(function (Get) {
    (function (Response) {
        Response.schema = z.discriminatedUnion("suretyType", [Get$1.Response.schema]);
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var Update;
(function (Update) {
    (function (Request) {
        Request.schema = z.object({
            sfaaCodeId: sfaaCodeId.nullable(),
        });
    })(Update.Request || (Update.Request = {}));
})(Update || (Update = {}));
var Import;
(function (Import) {
    (function (Request) {
        Request.schema = z.discriminatedUnion("suretyType", [Import$1.Request.schema]);
    })(Import.Request || (Import.Request = {}));
})(Import || (Import = {}));
var Close;
(function (Close) {
    (function (Request) {
        Request.schema = z.discriminatedUnion("suretyType", [Close$1.Request.schema]);
    })(Close.Request || (Close.Request = {}));
})(Close || (Close = {}));

export { Close, Get, Import, Trailing90DayGwp, Update };
